import { isValidPhone } from '@/helpers/validation';

export const TRAVELLER_ALLPAY_STATUS = {
  canHave: 'can-have',
  missingPhone: 'missing-phone',
  hasAllpay: 'has-allpay',
  ineligible: 'ineligible',
} as const;

export type TravellerAllpayStatus =
  (typeof TRAVELLER_ALLPAY_STATUS)[keyof typeof TRAVELLER_ALLPAY_STATUS];

export const getTravellerAllpayStatus = ({
  phone,
  hasAllpay,
  isActive,
}: {
  phone?: string;
  hasAllpay: boolean;
  isActive: boolean;
}): TravellerAllpayStatus => {
  if (hasAllpay) {
    return TRAVELLER_ALLPAY_STATUS.hasAllpay;
  }

  if (!isActive) {
    return TRAVELLER_ALLPAY_STATUS.ineligible;
  }

  if (!phone || !isValidPhone(phone)) {
    return TRAVELLER_ALLPAY_STATUS.missingPhone;
  }

  return TRAVELLER_ALLPAY_STATUS.canHave;
};
